var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _g3, _g4, _g5, _g6, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHigiene(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d086c830be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.386719 2.902344 L 22 2.902344 L 22 14 L 3.386719 14 Z M 3.386719 2.902344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed2f3e3b7d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 14 L 20 14 L 20 26.855469 L 12 26.855469 Z M 12 14 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6bca262331"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.386719 22 L 12 22 L 12 24 L 3.386719 24 Z M 3.386719 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c021b078e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 11 L 27.339844 11 L 27.339844 13 L 26 13 Z M 26 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dfe517a828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 15 L 27 15 L 27 26.855469 L 19 26.855469 Z M 19 15 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c204fafb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.386719 24 L 12 24 L 12 26.855469 L 3.386719 26.855469 Z M 3.386719 24 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.796875 5.71875 L 12.796875 4.792969 L 12.191406 4.1875 L 11.261719 4.1875 L 10.40625 5.042969 L 11.941406 6.574219 L 12.796875 5.71875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.539062 13.167969 L 25.628906 13.167969 L 25.628906 11.457031 L 22.632812 11.457031 C 21.601562 11.457031 20.738281 12.191406 20.539062 13.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 16.644531 8.035156 L 16.644531 6.324219 L 14.933594 6.324219 L 14.933594 8.035156 L 16.644531 8.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.367188 11.457031 L 12.367188 10.101562 C 12.367188 9.988281 12.324219 9.878906 12.242188 9.796875 L 10.785156 8.339844 C 10.617188 8.171875 10.617188 7.898438 10.785156 7.734375 L 11.335938 7.179688 L 9.800781 5.648438 L 6.933594 8.515625 C 6.851562 8.597656 6.808594 8.703125 6.808594 8.816406 L 6.808594 11.457031 L 12.367188 11.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 10.230469 13.167969 L 10.230469 12.3125 L 5.097656 12.3125 L 5.097656 13.570312 L 6.117188 21.722656 L 10.230469 21.722656 L 10.230469 18.65625 C 10.230469 18.65625 9.476562 19.3125 9.476562 19.316406 C 8.933594 19.789062 8.066406 19.671875 7.664062 19.074219 C 7.347656 18.597656 7.414062 17.945312 7.816406 17.542969 L 10.230469 15.128906 L 10.230469 14.023438 L 5.953125 14.023438 L 5.953125 13.167969 L 10.230469 13.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.355469 11.457031 L 18.355469 10.601562 L 15.363281 10.601562 L 15.363281 9.746094 L 17.753906 9.746094 L 16.898438 8.890625 L 14.683594 8.890625 L 13.222656 10.351562 L 13.222656 11.457031 L 18.355469 11.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 25.628906 15.621094 L 25.628906 14.023438 L 25.199219 14.023438 L 25.199219 14.878906 C 25.199219 15.195312 25.371094 15.472656 25.628906 15.621094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d086c830be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 4.242188 11.886719 C 4.242188 8.234375 6.679688 5.03125 10.183594 4.058594 L 10.785156 3.457031 C 10.863281 3.375 10.972656 3.332031 11.085938 3.332031 L 12.367188 3.332031 C 12.480469 3.332031 12.589844 3.375 12.671875 3.457031 L 12.996094 3.78125 C 14.929688 3.929688 16.738281 4.765625 18.113281 6.140625 C 19.5625 7.585938 20.394531 9.480469 20.488281 11.511719 C 20.722656 11.269531 20.996094 11.070312 21.296875 10.917969 C 21.070312 8.777344 20.082031 6.796875 18.496094 5.316406 C 16.828125 3.761719 14.652344 2.902344 12.367188 2.902344 C 9.96875 2.902344 7.714844 3.835938 6.019531 5.535156 C 4.320312 7.230469 3.386719 9.484375 3.386719 11.886719 L 3.386719 13.167969 L 4.242188 13.167969 L 4.242188 11.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 23.488281 14.878906 L 23.488281 14.023438 L 22.207031 14.023438 L 22.207031 14.878906 L 23.488281 14.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed2f3e3b7d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.929688 21.722656 C 17.929688 22.429688 17.355469 23.003906 16.644531 23.003906 C 16.328125 23.003906 16.027344 22.890625 15.789062 22.679688 C 15.554688 22.890625 15.253906 23.003906 14.933594 23.003906 C 14.617188 23.003906 14.316406 22.890625 14.078125 22.679688 C 13.84375 22.890625 13.542969 23.003906 13.222656 23.003906 C 12.90625 23.003906 12.605469 22.890625 12.367188 22.679688 L 12.367188 26.855469 L 17.980469 26.855469 L 19.582031 14.023438 L 17.929688 14.023438 L 17.929688 21.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6bca262331)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 3.386719 23.433594 L 11.511719 23.433594 L 11.511719 22.578125 L 3.386719 22.578125 L 3.386719 23.433594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c021b078e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 26.484375 11.886719 L 26.484375 12.742188 L 27.339844 12.742188 L 27.339844 11.886719 L 26.484375 11.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dfe517a828)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.921875 20.867188 L 25.554688 20.867188 L 25.539062 20.851562 C 24.3125 19.417969 23.59375 17.613281 23.5 15.734375 L 22.195312 15.734375 C 22.101562 17.613281 21.382812 19.417969 20.15625 20.851562 L 19.640625 21.453125 L 19.640625 26.425781 C 19.640625 26.664062 19.832031 26.855469 20.066406 26.855469 L 25.628906 26.855469 C 25.863281 26.855469 26.054688 26.664062 26.054688 26.425781 L 26.054688 21.722656 L 20.921875 21.722656 L 20.921875 20.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c204fafb7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 4.242188 25.144531 L 5.097656 25.144531 L 5.097656 26 L 4.242188 26 Z M 5.953125 24.714844 L 6.808594 24.714844 L 6.808594 25.570312 L 5.953125 25.570312 Z M 9.800781 25.144531 L 10.65625 25.144531 L 10.65625 26 L 9.800781 26 Z M 3.386719 26.855469 L 11.511719 26.855469 L 11.511719 24.289062 L 3.386719 24.289062 L 3.386719 26.855469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.796875 21.722656 C 12.796875 21.835938 12.839844 21.945312 12.921875 22.027344 C 13.003906 22.105469 13.109375 22.148438 13.222656 22.148438 C 13.339844 22.148438 13.445312 22.105469 13.527344 22.023438 C 13.609375 21.945312 13.652344 21.835938 13.652344 21.722656 L 13.652344 18.300781 L 14.507812 18.300781 L 14.507812 21.722656 C 14.507812 21.835938 14.550781 21.945312 14.632812 22.027344 C 14.714844 22.105469 14.820312 22.148438 14.933594 22.148438 C 15.050781 22.148438 15.15625 22.105469 15.238281 22.023438 C 15.320312 21.945312 15.363281 21.835938 15.363281 21.722656 L 15.363281 18.300781 L 16.21875 18.300781 L 16.21875 21.722656 C 16.21875 21.835938 16.261719 21.945312 16.34375 22.027344 C 16.425781 22.105469 16.53125 22.148438 16.644531 22.148438 C 16.882812 22.148438 17.074219 21.957031 17.074219 21.722656 L 17.074219 12.3125 L 11.085938 12.3125 L 11.085938 15.308594 C 11.085938 15.421875 11.039062 15.527344 10.960938 15.609375 C 10.960938 15.609375 8.425781 18.144531 8.421875 18.148438 C 8.304688 18.265625 8.285156 18.460938 8.378906 18.601562 C 8.496094 18.777344 8.753906 18.8125 8.914062 18.671875 L 10.375 17.390625 C 10.503906 17.28125 10.683594 17.253906 10.835938 17.324219 C 10.988281 17.390625 11.085938 17.542969 11.085938 17.710938 L 11.085938 21.722656 L 11.941406 21.722656 L 11.941406 18.300781 L 12.796875 18.300781 L 12.796875 21.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 19.640625 12.3125 L 17.929688 12.3125 L 17.929688 13.167969 L 19.640625 13.167969 L 19.640625 12.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigiene);
export default __webpack_public_path__ + "static/media/Higiene.a90af92b586667208ea03a7d3766e162.svg";
export { ForwardRef as ReactComponent };